import React, { useState, useEffect, useRef } from 'react';
import classes from './ScrollInfo.module.scss';

// let offsetY = 0;

const ScrollInfo = ({ children, color = '#000', parentClass, small, grad, clicked, className, style }) => {
  const rootClass = [classes.ScrollInfo];
  if (className) rootClass.push(className);
  if (small) rootClass.push(classes.Small);

  const [transY, setTransY] = useState(0);
  const [offsetY, setOffsetY] = useState(0);
  const mainRef = useRef();

  useEffect(()=> {
    const parent = mainRef.current.closest('.' + parentClass);
    
    if (parent) {
      const pRect = parent.getBoundingClientRect();
    
      setOffsetY(pRect.top);
    }

    const scrollHandler = ()=> {
      setTransY(window.pageYOffset);
    }
    window.addEventListener('scroll', scrollHandler);

    return ()=> window.removeEventListener('scroll', scrollHandler);
  }, [parentClass]);
  // console.log(transY, offsetY);

  const styles = {
    // bottom: 32 - offsetY,
    transform: `translate(0, ${transY - offsetY}px) rotate3d(0, 0, 1, -90deg)`,
    ...style
  };
  if (clicked) {
    styles.cursor = 'pointer'
  };
  if (grad) {
    rootClass.push(classes.Grad);
  }

  return (
    <div className={rootClass.join(' ')} style={styles} ref={mainRef}
      onClick={()=> clicked ? clicked() : 0}
    >
      <div className={classes.Contents}>
        <h4 className={classes.Text} style={{ color: color }}>{children}</h4>
        <div className={classes.Line} style={{ backgroundColor: !grad ? color:null }}></div>
      </div>
    </div>
  );
}

export default React.memo(ScrollInfo);